import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logger from '../lib/logger';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { processGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment (primary) or query params (fallback)
        let sessionId = null;

        const hash = window.location.hash;
        if (hash?.includes('session_id=')) {
          const params = new URLSearchParams(hash.substring(1));
          sessionId = params.get('session_id');
        }

        if (!sessionId) {
          const searchParams = new URLSearchParams(window.location.search);
          sessionId = searchParams.get('session_id');
        }

        if (!sessionId) {
          logger.error('[AuthCallback] No session_id found in URL:', window.location.href);
          navigate('/login', { replace: true });
          return;
        }

        // Exchange session_id for session token
        const userData = await processGoogleSession(sessionId);

        if (!userData || !userData.email) {
          logger.error('[AuthCallback] processGoogleSession returned invalid data:', userData);
          navigate('/login', { replace: true });
          return;
        }

        // Clean the URL hash before navigating (prevents stale session_id on back-nav)
        if (window.history.replaceState) {
          window.history.replaceState(null, '', window.location.pathname);
        }

        // Navigate to estimator
        navigate('/workspaces', { replace: true });
      } catch (error) {
        logger.error('[AuthCallback] Auth processing failed:', error?.response?.status, error?.response?.data || error?.message);
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [navigate, processGoogleSession]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#4ABFCF] border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-slate-600">Completing sign in...</p>
      </div>
    </div>
  );
}
